export const QuoteFields = `
{
    body
}
`;
